module.exports = __webpack_public_path__ + "img/coingate.f49da1fe.svg";